import { render, staticRenderFns } from "./AccountInformation.vue?vue&type=template&id=20d0bc09&scoped=true"
import script from "./AccountInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountInformation.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AccountInformation.vue?vue&type=style&index=0&id=20d0bc09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d0bc09",
  null
  
)

export default component.exports